import { FormData } from "../../data/models";
import axios from "axios";
import { toast } from "react-toastify";
import { getUTMTrackingData } from "../utils";

// [SECURITY]
const MAX_BYTES = 50 * 1024;

// [SECURITY]
const toastMsgForStatus = (status?: number) => {
  switch (status) {
    case 401: return "Molimo prijavite se kako biste nastavili.";
    case 403: return "Nemate ovlasti za ovu radnju.";
    case 413: return "Poruka je prevelika. Skratite sadržaj i pokušajte ponovno.";
    case 400:
    case 422: return "Neispravni podaci u obrascu. Provjerite unesena polja.";
    case 429: return "Previše pokušaja. Pokušajte kasnije.";
    default: return "Došlo je do pogreške pri slanju upita.";
  }
};

export const sendEmail = async ({
  formData,
  mode,
  id,
}: {
  formData: FormData;
  mode: string;
  id: string | undefined;
}) => {
  const formattedData = formatDataForBackend(formData);

  // [SECURITY] CLIENT-SIDE GUARD: izmjeri veličinu JSON-a i zaustavi prevelike requeste
  const json = JSON.stringify(formattedData);
  const byteSize = new TextEncoder().encode(json).length;
  if (byteSize > MAX_BYTES) {
    toast.error(`Poruka je prevelika (${byteSize} B > ${MAX_BYTES} B). Skratite sadržaj i pokušajte ponovno.`);
    return;
  }


  if (mode === "Zatražite ponudu") {
    try {
      const response = await axios.post(
        `https://findmyclues-api.azurewebsites.net/api/v1/vehicles/${id}/offer/?brand=PEUGEOT`,
        formattedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Upit uspjesno poslan!");
      toast.success(
        "Hvala Vam na upitu. Uskoro će vas kontaktirati PEUGEOT prodajni savjetnik."
      );
      //console.log("Response from server:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // [SECURITY]
        const status = error.response?.status;
        // console.error("Axios error (offer):", status, error.response?.data || error.message);
        toast.error(toastMsgForStatus(status));
      } else {
        // console.error("Unexpected error:", error);
        toast.error("Neočekivana pogreška pri slanju upita.");
      }
    }
  } else {
    try {
      //console.log(formattedData);
      const response = await axios.post(
        `https://findmyclues-api.azurewebsites.net/api/v1/vehicles/${id}/test/?brand=PEUGEOT`,
        formattedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Upit uspjesno poslan!");
      toast.success(
        "Hvala Vam na upitu. Uskoro će vas kontaktirati PEUGEOT prodajni savjetnik."
      );
      //console.log("Response from server:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        toast.error(toastMsgForStatus(status));
      } else {
        // console.error("Unexpected error:", error);
      }
    }
  }
};

export const formatDataForBackend = (formData: FormData) => {
  const formattedData: Record<string, any> = {
    first_name: formData.general["Ime"],
    last_name: formData.general["Prezime"],
    email: formData.general["Email adresa"],
    phone: formData.general["Mobilni telefon"],
    location: formData.general["Mjesto"],
    postalcode: formData.general["Poštanski broj"],
    street: formData.general["Ulica"],
    house_number: formData.general["Kućni broj"],
    car_info: {
      vin: formData.vehicle["Broj šasije vozila"],
      model: formData.vehicle["Model vozila"],
    },
    ...getUTMTrackingData(), // Add UTM tracking data
  };

  if (formData.conditions.includes("newsletter")) {
    formattedData.newsletter = true;
  } else {
    formattedData.newsletter = false;
  }
  if (formData.conditions.includes("analyticsConsent")) {
    formattedData.analytics = true;
  } else {
    formattedData.analytics = false;
  }

  // Add `additional` only if filled out
  if (formData.additional["Naslov"] || formData.additional["Poruka"]) {
    formattedData.additional = {
      title: formData.additional["Naslov"],
      message: formData.additional["Poruka"],
    };
  }

  return formattedData;
};
